module.exports = __webpack_public_path__ + "static/img/class3.14b8076.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/class3.png
// module id = 0LkS
// module chunks = 0